import { t, Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import { dataArrayUnique, testAppendAttr } from "@smp/utils";
import differenceInDays from "date-fns/differenceInDays";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

import { useDateCurrent } from "@/hooks/use_date_current";
import { useDialog } from "@/hooks/use_dialog";
import { useEpPageconfigListRecursive } from "@/hooks/use_ep_pageconfig";
import { useContextApp } from "@/screens/app/context/app";

import { HeaderButton } from "../../shared";
import { DialogRecurring } from "./dialog_recurring";

export const Recurring = () => {
  const {
    state: {
      isRecurringPaymentListLoading,
      planLast,
      plansubscriptionList,
      recurringPaymentActive,
      recurringPaymentLast,
    },
  } = useContextApp();

  const { dateCurrent } = useDateCurrent();

  const {
    close: dialogClose,
    isOpen: isDialogOpen,
    open: dialogOpen,
  } = useDialog();

  const { isPageconfigListLoading, pageconfigList } =
    useEpPageconfigListRecursive({
      req: {
        query: { all_organization_contexts: "True", has_scheduled_posts: true },
      },
    });

  const pagesUsed = pageconfigList
    ? dataArrayUnique(
        pageconfigList.map(
          (pageconfig) => `${pageconfig.medium}:${pageconfig.external_id}`,
        ),
      ).length
    : undefined;

  const plansubscriptionLast = plansubscriptionList
    ? plansubscriptionList[0]
    : undefined;

  const plansubscriptionActive = plansubscriptionLast
    ? parseISO(plansubscriptionLast.period_end).getTime() >=
      new Date().getTime()
      ? plansubscriptionLast
      : undefined
    : undefined;

  const pagesLimit = planLast ? planLast.social_pages_limit : 0;

  const isLoading = isPageconfigListLoading || isRecurringPaymentListLoading;

  const captionLeft = (() => {
    if (!!recurringPaymentActive) {
      return <Trans>__dialog_recurring__Active</Trans>;
    }

    if (!!recurringPaymentLast) {
      const plansubscriptionLastDaysLeft = plansubscriptionLast
        ? (() => {
            const diff = differenceInDays(
              parseISO(plansubscriptionLast.period_end),
              dateCurrent,
            );
            return diff > 0 ? diff : 0;
          })()
        : undefined;

      if (!plansubscriptionLastDaysLeft || plansubscriptionLastDaysLeft <= 0) {
        return undefined;
      }
      if (!!plansubscriptionActive) {
        return <Trans>__dialog_recurring__Expires</Trans>;
      }
    }

    if (!recurringPaymentLast) {
      if (!plansubscriptionActive) {
        return undefined;
      }
      if (!!plansubscriptionActive) {
        return (
          <UiTypography style={{ fontSize: 10, lineHeight: "10px" }}>
            <Trans>until</Trans>{" "}
            {format(parseISO(plansubscriptionActive.period_end), "dd.MM.yyyy")}
          </UiTypography>
        );
      }
    }

    return <Trans>No subscription</Trans>;
  })();

  const isExpired = (() => {
    if (!!recurringPaymentActive) {
      return false;
    }

    if (!!recurringPaymentLast) {
      const plansubscriptionLastDaysLeft = plansubscriptionLast
        ? (() => {
            const diff = differenceInDays(
              parseISO(plansubscriptionLast.period_end),
              dateCurrent,
            );
            return diff > 0 ? diff : 0;
          })()
        : undefined;

      if (!plansubscriptionLastDaysLeft || plansubscriptionLastDaysLeft <= 0) {
        return true;
      }
      if (!!plansubscriptionActive) {
        return false;
      }
    } else {
      return !!plansubscriptionActive ? false : true;
    }

    return false;
  })();

  if (isLoading) {
    return null;
  }

  return (
    <>
      <HeaderButton
        captionLeft={captionLeft}
        onClick={dialogOpen}
        isExpired={isExpired}
        textLeft={
          <span style={{ display: "block", fontSize: 16, lineHeight: "16px" }}>
            {isExpired ? (
              <Trans>Expired</Trans>
            ) : (
              `${pagesUsed} ${t`of`} ${pagesLimit}`
            )}
          </span>
        }
        {...testAppendAttr("id", "header_billing_recurring")}
      />
      {isDialogOpen && (
        <DialogRecurring onClose={dialogClose} open={isDialogOpen} />
      )}
    </>
  );
};
